import type { CpfReport, IScoreApiResponse, Notification } from "@tally/types";
import { alovaScoreInstance } from "./alovaScoreInstance";

export const useApiScore = () => {
	const notificationRequest = {
		send: () =>
			alovaScoreInstance.Get<IScoreApiResponse<Notification[]>>(
				"/v1/notification",
			),
	};

	const notificationMarkAsRead = {
		send: (payload: unknown) =>
			alovaScoreInstance.Patch<IScoreApiResponse<Notification[]>>(
				"/v1/notification",
				payload,
			),
	};

	const notificationDelete = {
		send: (payload: unknown) =>
			alovaScoreInstance.Delete<IScoreApiResponse<Notification>>(
				"/v1/notification",
				payload,
			),
	};

	const CpfReport = {
		send: (payload: unknown) =>
			alovaScoreInstance.Post<IScoreApiResponse<CpfReport>>(
				"/v1/user/report",
				payload,
			),
	};

	return {
		notificationRequest,
		notificationMarkAsRead,
		notificationDelete,
		CpfReport,
	};
};
